<template>
    <ManageSidebar />
    <DevelopmentContainer>
        <DevelopmentMessage>
            <DevelopmentIcon>🚧</DevelopmentIcon>
            <MessageText>통계관리는 현재 개발중인 서비스입니다</MessageText>
        </DevelopmentMessage>
    </DevelopmentContainer>
</template>

<script>
import ManageSidebar from './ManageSidebar.vue';
import * as ManageDataCss from '@/assets/styles/manage/ManageDataCss.js';

export default {
    name: 'ManageData',

    components: {
        ManageSidebar,
        ...ManageDataCss
    }
}
</script>